module.exports = __webpack_public_path__ + "static/5-72c0d19ca1fea90718c612c54b0ce800.jpg";